import React, { PureComponent, Dispatch } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { SofaProgressBar } from '@sofology/sofologycomponents';

import './BasketCheckoutContainer.scss';

import { AppState } from 'store';
import { externalComponentsHelper, progressBarHelper, generateDispatchToPropsMap, paymentHelper, scrollHelper, analyticsHelper } from 'helpers';
import { CheckoutTrustpilot } from './CheckoutTrustpilot/CheckoutTrustpilot';
import { CheckoutHeader } from './CheckoutHeader/CheckoutHeader';
import { CheckoutFooter } from './CheckoutFooter/CheckoutFooter';
import { PaymentTypes } from 'models/Payment';
import { SaveCurrentPageFunc, saveCurrentPage } from 'store/basket/actions';
import { routes } from 'routes';

const SCROLL_TIMEOUT = 750;

interface OwnProps {
}

interface StateProps {
    paymentType: PaymentTypes;
    isOrderOnSummaryPageExists: boolean;
}

interface DispatchProps {
    saveCurrentPage: SaveCurrentPageFunc;
}

class BasketCheckoutContainer extends PureComponent<OwnProps & StateProps & DispatchProps & RouteComponentProps> {
    componentDidMount() {
        externalComponentsHelper.hideUmbracoHeaderFooter();

        // should be wrapped to setTimeout, because otherwise it does not work after refresh page - render too fast
        setTimeout(() => scrollHelper.scrollToTopPage(), SCROLL_TIMEOUT);

        let currentLocation = this.getCurrentLocation();

        this.props.saveCurrentPage(currentLocation);
        analyticsHelper.sendToGoogleDefaultPageViewMessage(currentLocation);
    }

    componentDidUpdate(prevProps: Readonly<RouteComponentProps>) {
        let currentLocation = this.getCurrentLocation();

        this.props.saveCurrentPage(currentLocation);

        if (prevProps.location.pathname !== this.props.location.pathname) {
            // should be wrapped to setTimeout, because otherwise it does not work when moving back through the browser history
            setTimeout(() => scrollHelper.scrollToTopPage(), 0);
            analyticsHelper.sendToGoogleDefaultPageViewMessage(currentLocation);
        }
    }

    render(): JSX.Element {
        return (
            <div className='basket-checkout-container'>
                <div className='basket-checkout-container__trustpilot-wrapper'>
                    <div className='basket-checkout-container__trustpilot'>
                        <CheckoutTrustpilot />
                    </div>
                </div>
                <div className='basket-checkout-container__header-wrapper'>
                    <CheckoutHeader />
                </div>
                <div className='basket-checkout-container__state-wrapper'>
                    <div className='basket-checkout-container__state'>
                        <SofaProgressBar
                            steps={progressBarHelper.getCheckoutSteps(this.getCurrentLocation(), this.props.paymentType)}
                            isLastStepPassed={this.isLastStepPassed()}
                        />
                    </div>
                </div>
                <div className='basket-checkout-container__content-wrapper'>
                    <div className='basket-checkout-container__content'>
                        {this.props.children}
                    </div>
                </div>
                <div className='basket-checkout-container__footer-wrapper'>
                    <CheckoutFooter />
                </div>
            </div>
        );
    }

    isLastStepPassed() {
        const { paymentType, isOrderOnSummaryPageExists } = this.props;

        const isSummaryPage = this.getCurrentLocation() === routes.orderSummaryPage.path;

        if (isSummaryPage && isOrderOnSummaryPageExists) {
            if (paymentHelper.isCardRelatedPaymentType(paymentType)) {
                return true;
            }

            if (paymentHelper.isCreditRelatedPaymentType(paymentType)) {
                return true;
            }
        }

        return false;
    }

    getCurrentLocation(): string {
        return this.props.location.pathname;
    }
}

function mapStateToProps(state: AppState): StateProps {
    return {
        paymentType: state.paymentState.paymentDetails.paymentType,
        isOrderOnSummaryPageExists: Boolean(state.checkoutState.order)
    };
}

function mapDispatchToProps(dispatch: Dispatch<any>): DispatchProps {
    return generateDispatchToPropsMap(dispatch, [saveCurrentPage]);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasketCheckoutContainer));